<template>
	<div class="report-claim">
		<Modal :show="showReportClaim" @close="closeModal">
			<template #content>
				<div class="p-6 md:p-8 max-w-2xl mx-auto">
					<!-- Header with close button -->
					<div class="flex items-center justify-between mb-8">
						<h1
							class="text-2xl md:text-3xl font-bold text-gray-900"
						>
							Report a Claim
						</h1>
						<button
							@click="closeModal"
							class="text-gray-500 hover:text-gray-800 focus:outline-none transition-colors"
							aria-label="Close"
						>
							<svg
								class="w-8 h-8"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
					</div>

					<!-- Form -->
					<form @submit.prevent="handleSubmit" class="space-y-8">
						<!-- Claim Type Selection -->
						<div>
							<label
								class="block text-lg font-semibold text-gray-800 mb-4"
							>
								Select Claim Type
								<span class="text-red-500 text-base">*</span>
							</label>

							<div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
								<!-- Damage Option -->
								<label class="claim-type-card">
									<input
										type="radio"
										v-model="form.claim_type"
										value="damage"
										class="sr-only"
										required
									/>
									<div
										class="claim-type-content"
										:class="{
											selected:
												form.claim_type === 'damage',
										}"
									>
										<div class="icon-container">
											<!-- Damage / Collision icon -->

											<svg
												fill="#000000"
												height="100px"
												width="100px"
												version="1.1"
												id="Capa_1"
												xmlns="http://www.w3.org/2000/svg"
												xmlns:xlink="http://www.w3.org/1999/xlink"
												viewBox="0 0 440 440"
												xml:space="preserve"
											>
												<g
													id="SVGRepo_bgCarrier"
													stroke-width="0"
												></g>
												<g
													id="SVGRepo_tracerCarrier"
													stroke-linecap="round"
													stroke-linejoin="round"
													stroke="#00347"
													stroke-width="35.2"
												>
													<g>
														<path
															d="M263,355.713c20.52,0,37.213-16.694,37.213-37.213S283.52,281.287,263,281.287s-37.213,16.694-37.213,37.213 S242.48,355.713,263,355.713z M263,299.287c10.594,0,19.213,8.619,19.213,19.213s-8.619,19.213-19.213,19.213 s-19.213-8.619-19.213-19.213S252.406,299.287,263,299.287z"
														></path>
														<path
															d="M440,210.5c0-4.971-4.029-9-9-9h-91.701v-27.088l25.092-19.09c4.933-3.754,11.059-5.822,17.249-5.822H431 c4.971,0,9-4.029,9-9s-4.029-9-9-9h-49.36c-10.105,0-20.104,3.374-28.149,9.498l-80.207,61.021l-1.5,0.266l-31.404-74.731 c-8.793-20.926-24.666-38.333-44.694-49.014c-4.39-2.34-9.839-0.68-12.177,3.707c-2.339,4.386-0.68,9.837,3.706,12.176 c16.389,8.74,29.376,22.982,36.571,40.104l29.828,70.982l-86.222,15.299c-12.59,2.227-23.801,9.666-30.762,20.417l-5.426,8.394 c-6.021,9.3-9.205,20.075-9.205,31.162c0,8.139,1.69,16.043,5.031,23.51c3.34,7.427,8.122,13.942,14.223,19.37l7.316,6.497 c9.68,8.604,22.142,13.343,35.09,13.343h21.525c9.695,22.334,31.956,38,57.814,38s48.119-15.666,57.814-38H431c4.971,0,9-4.029,9-9 s-4.029-9-9-9H325.602c0.255-2.3,0.398-4.633,0.398-7c0-3.022-0.227-5.99-0.64-8.9H431c4.971,0,9-4.029,9-9s-4.029-9-9-9H319.954 c-10.11-21.318-31.835-36.1-56.954-36.1s-46.844,14.782-56.954,36.1h-64.524c-0.848-2.963-1.344-6.004-1.477-9.1h25.43 c11.317,0,20.525-9.208,20.525-20.525s-9.208-20.525-20.525-20.525h-3.336c2.608-1.398,5.437-2.396,8.394-2.918L277.793,219.5H431 C435.971,219.5,440,215.471,440,210.5z M263,273.5c24.813,0,45,20.187,45,45s-20.187,45-45,45s-45-20.187-45-45 S238.187,273.5,263,273.5z M200.398,325.5H183.66c-8.535,0-16.75-3.124-23.135-8.8l-7.313-6.494 c-0.222-0.197-0.43-0.405-0.647-0.606h48.075c-0.413,2.909-0.64,5.878-0.64,8.9C200,320.867,200.143,323.2,200.398,325.5z M168,261.975c0,1.392-1.133,2.525-2.525,2.525h-21.946c0.792-1.739,1.71-3.427,2.757-5.05h19.189 C166.867,259.45,168,260.583,168,261.975z M321.299,201.5h-17.605l17.605-13.394V201.5z"
														></path>
														<path
															d="M404,235.5c-4.971,0-9,4.029-9,9s4.029,9,9,9h24c4.971,0,9-4.029,9-9s-4.029-9-9-9H404z"
														></path>
														<path
															d="M140.997,208.43c5.688,3.293,12.201,5.07,19.003,5.07c20.953,0,38-17.047,38-38c0-14.282-7.988-27.027-20.062-33.502 c2.246-6.074,3.41-12.529,3.41-19.079c0-30.327-24.673-55-55-55s-55,24.673-55,55c0,0.101,0,0.201,0.001,0.302 c-25.441,7.164-43.726,30.64-43.726,57.748c0,33.084,26.916,60,60,60C110.535,240.968,130.912,228.101,140.997,208.43z M87.624,222.968c-23.159,0-42-18.841-42-42c0-19.3,13.234-35.968,31.513-40.666c1.626-0.418,8.712-1.334,10.487-1.334 c12.578,0,24.39,5.57,32.407,15.281c1.779,2.156,4.353,3.271,6.945,3.271c2.018,0,4.048-0.675,5.725-2.06 c3.833-3.164,4.375-8.837,1.211-12.67c-11.07-13.41-27.215-21.267-44.515-21.773c0.993-19.522,17.187-35.098,36.952-35.098 c20.401,0,37,16.598,37,37c0,6.865-1.897,13.569-5.486,19.388c-1.553,2.517-1.77,5.636-0.58,8.343 c1.188,2.708,3.632,4.658,6.536,5.218C173.194,157.677,180,165.934,180,175.5c0,11.028-8.972,20-20,20 c-6.206,0-11.959-2.817-15.785-7.73c-2.116-2.718-5.602-3.988-8.969-3.274c-3.37,0.715-6.036,3.291-6.866,6.634 C123.723,209.876,106.964,222.968,87.624,222.968z"
														></path>
														<path
															d="M59,88c0-16.267-13.233-29.5-29.5-29.5S0,71.733,0,88s13.233,29.5,29.5,29.5S59,104.267,59,88z M18,88 c0-6.341,5.159-11.5,11.5-11.5S41,81.659,41,88s-5.159,11.5-11.5,11.5S18,94.341,18,88z"
														></path>
													</g>
												</g>
												<g id="SVGRepo_iconCarrier">
													<g>
														<path
															d="M263,355.713c20.52,0,37.213-16.694,37.213-37.213S283.52,281.287,263,281.287s-37.213,16.694-37.213,37.213 S242.48,355.713,263,355.713z M263,299.287c10.594,0,19.213,8.619,19.213,19.213s-8.619,19.213-19.213,19.213 s-19.213-8.619-19.213-19.213S252.406,299.287,263,299.287z"
														></path>
														<path
															d="M440,210.5c0-4.971-4.029-9-9-9h-91.701v-27.088l25.092-19.09c4.933-3.754,11.059-5.822,17.249-5.822H431 c4.971,0,9-4.029,9-9s-4.029-9-9-9h-49.36c-10.105,0-20.104,3.374-28.149,9.498l-80.207,61.021l-1.5,0.266l-31.404-74.731 c-8.793-20.926-24.666-38.333-44.694-49.014c-4.39-2.34-9.839-0.68-12.177,3.707c-2.339,4.386-0.68,9.837,3.706,12.176 c16.389,8.74,29.376,22.982,36.571,40.104l29.828,70.982l-86.222,15.299c-12.59,2.227-23.801,9.666-30.762,20.417l-5.426,8.394 c-6.021,9.3-9.205,20.075-9.205,31.162c0,8.139,1.69,16.043,5.031,23.51c3.34,7.427,8.122,13.942,14.223,19.37l7.316,6.497 c9.68,8.604,22.142,13.343,35.09,13.343h21.525c9.695,22.334,31.956,38,57.814,38s48.119-15.666,57.814-38H431c4.971,0,9-4.029,9-9 s-4.029-9-9-9H325.602c0.255-2.3,0.398-4.633,0.398-7c0-3.022-0.227-5.99-0.64-8.9H431c4.971,0,9-4.029,9-9s-4.029-9-9-9H319.954 c-10.11-21.318-31.835-36.1-56.954-36.1s-46.844,14.782-56.954,36.1h-64.524c-0.848-2.963-1.344-6.004-1.477-9.1h25.43 c11.317,0,20.525-9.208,20.525-20.525s-9.208-20.525-20.525-20.525h-3.336c2.608-1.398,5.437-2.396,8.394-2.918L277.793,219.5H431 C435.971,219.5,440,215.471,440,210.5z M263,273.5c24.813,0,45,20.187,45,45s-20.187,45-45,45s-45-20.187-45-45 S238.187,273.5,263,273.5z M200.398,325.5H183.66c-8.535,0-16.75-3.124-23.135-8.8l-7.313-6.494 c-0.222-0.197-0.43-0.405-0.647-0.606h48.075c-0.413,2.909-0.64,5.878-0.64,8.9C200,320.867,200.143,323.2,200.398,325.5z M168,261.975c0,1.392-1.133,2.525-2.525,2.525h-21.946c0.792-1.739,1.71-3.427,2.757-5.05h19.189 C166.867,259.45,168,260.583,168,261.975z M321.299,201.5h-17.605l17.605-13.394V201.5z"
														></path>
														<path
															d="M404,235.5c-4.971,0-9,4.029-9,9s4.029,9,9,9h24c4.971,0,9-4.029,9-9s-4.029-9-9-9H404z"
														></path>
														<path
															d="M140.997,208.43c5.688,3.293,12.201,5.07,19.003,5.07c20.953,0,38-17.047,38-38c0-14.282-7.988-27.027-20.062-33.502 c2.246-6.074,3.41-12.529,3.41-19.079c0-30.327-24.673-55-55-55s-55,24.673-55,55c0,0.101,0,0.201,0.001,0.302 c-25.441,7.164-43.726,30.64-43.726,57.748c0,33.084,26.916,60,60,60C110.535,240.968,130.912,228.101,140.997,208.43z M87.624,222.968c-23.159,0-42-18.841-42-42c0-19.3,13.234-35.968,31.513-40.666c1.626-0.418,8.712-1.334,10.487-1.334 c12.578,0,24.39,5.57,32.407,15.281c1.779,2.156,4.353,3.271,6.945,3.271c2.018,0,4.048-0.675,5.725-2.06 c3.833-3.164,4.375-8.837,1.211-12.67c-11.07-13.41-27.215-21.267-44.515-21.773c0.993-19.522,17.187-35.098,36.952-35.098 c20.401,0,37,16.598,37,37c0,6.865-1.897,13.569-5.486,19.388c-1.553,2.517-1.77,5.636-0.58,8.343 c1.188,2.708,3.632,4.658,6.536,5.218C173.194,157.677,180,165.934,180,175.5c0,11.028-8.972,20-20,20 c-6.206,0-11.959-2.817-15.785-7.73c-2.116-2.718-5.602-3.988-8.969-3.274c-3.37,0.715-6.036,3.291-6.866,6.634 C123.723,209.876,106.964,222.968,87.624,222.968z"
														></path>
														<path
															d="M59,88c0-16.267-13.233-29.5-29.5-29.5S0,71.733,0,88s13.233,29.5,29.5,29.5S59,104.267,59,88z M18,88 c0-6.341,5.159-11.5,11.5-11.5S41,81.659,41,88s-5.159,11.5-11.5,11.5S18,94.341,18,88z"
														></path>
													</g>
												</g>
											</svg>
										</div>
										<h3 class="mt-3 text-lg font-medium">
											Damage / Collision
										</h3>
									</div>
								</label>

								<!-- Accident Option -->
								<label class="claim-type-card">
									<input
										type="radio"
										v-model="form.claim_type"
										value="accident"
										class="sr-only"
									/>
									<div
										class="claim-type-content"
										:class="{
											selected:
												form.claim_type === 'accident',
										}"
									>
										<div class="icon-container">
											<!-- Accident SVG (keep your original) -->

											<svg
												fill="#000000"
												height="100px"
												width="100px"
												version="1.1"
												id="Layer_1"
												xmlns="http://www.w3.org/2000/svg"
												xmlns:xlink="http://www.w3.org/1999/xlink"
												viewBox="0 0 512 512"
												xml:space="preserve"
											>
												<g
													id="SVGRepo_bgCarrier"
													stroke-width="0"
												></g>
												<g
													id="SVGRepo_tracerCarrier"
													stroke-linecap="round"
													stroke-linejoin="round"
												></g>
												<g id="SVGRepo_iconCarrier">
													<g>
														<g>
															<path
																d="M150.075,124.106l-16.291-64.642c-2.242-8.898-11.297-14.359-20.257-12.102c-8.94,2.252-14.355,11.323-12.102,20.257 l14.105,55.968l-42.671,46.975l9.612-19.91l-24.591-2.216c-13.689-1.177-25.741,8.966-26.918,22.657l-9.795,127.271 c0,0,2.348,15.228,12.037,76.917l-31.91,84.602c-3.902,10.346,1.322,21.898,11.669,25.8c10.341,3.903,21.898-1.319,25.8-11.668 l33.775-89.55c1.223-3.243,1.582-6.747,1.046-10.172l-11.367-72.401l10.56,0.908l31.06,68.73l1.294,95.69 c0.148,10.965,9.083,19.752,20.016,19.752c0.091,0,0.185,0,0.277-0.002c11.056-0.149,19.899-9.234,19.75-20.292l-1.351-99.862 c-0.037-2.752-0.642-5.466-1.774-7.975l-27.522-60.902l10.085-120.864l-25.483,14.2l47.117-51.872 C149.964,135.309,151.454,129.583,150.075,124.106z"
															></path>
														</g>
													</g>
													<g>
														<g>
															<path
																d="M84.173,64.689C68.16,67.534,55.401,80.81,53.941,97.785c-1.813,21.082,14.529,39.593,36.09,39.969l8.469-16.18 L84.173,64.689z"
															></path>
														</g>
													</g>
													<g>
														<g>
															<path
																d="M400.954,73.455c-18.785-23.802-9.889-39.269-4.821-45.112c1.055-1.216,0.263-3.127-1.344-3.244 c-7.733-0.561-24.721,1.354-33.865,26.53c-0.019,0.052-0.031,0.107-0.049,0.158c-3.814-5.095-10.337-7.262-15.588-8.175 c-1.999-0.347-3.153,2.238-1.554,3.485c18.942,14.786-12.311,29.557-20.91,45.933c-1.344,2.56-2.334,4.993-3.036,7.31 c-1.357-0.672-2.732-1.331-4.149-1.963c-48.698-21.735-47.472-53.093-44.349-66.333c0.65-2.758-2.144-5.085-4.742-3.955 c-12.505,5.442-37.4,22.297-31.085,68.982c0.013,0.096,0.039,0.191,0.053,0.287c-10.102-4.822-22.032-2.871-30.957-0.006 c-3.396,1.092-3.083,6.061,0.428,6.699c41.581,7.565,4.961,56.094,4.939,88.625c-0.001,2.577,0.114,5.03,0.328,7.37 c10.348,0.897,20.453,4.641,28.883,10.776c3.724,2.71,7.061,5.811,9.978,9.243c-3.985-16.09-1.86-34.278,5.002-46.7 c10.286-18.621,8.928-30.899,3.035-46.399c-1.055-2.775,1.67-5.567,4.439-4.495c17.603,6.812,30.471,30.214,29.947,51.026 c-0.067,2.637,2.747,4.384,5.07,3.134c4.942-2.657,11.634-7.944,13.147-17.505c0.279-1.762,1.776-3.123,3.558-3.018 c13.552,0.798,26.215,12.978,33.601,29.313c2.626-13.269,9.91-25.324,20.583-33.821c-5.486-14.51-15.184-28.842-30.182-40.388 c2.892-6.799,7.614-12.78,12.859-16.241c10.096-6.661,12.654-13.203,13.778-22.564c0.201-1.676,2.31-2.363,3.422-1.092 c7.065,8.078,7.368,23.26,1.609,33.601c-0.73,1.311,0.226,2.932,1.726,2.917c3.191-0.033,7.956-0.929,11.243-5.344 c0.605-0.813,1.719-1.104,2.587-0.581c9.912,5.965,12.074,24.271,5.451,38.782c3.958-0.935,7.994-1.441,12.05-1.518 C413.74,126.498,420.721,98.501,400.954,73.455z"
															></path>
														</g>
													</g>
													<g>
														<g>
															<path
																d="M438.539,185.58c-6.005-19.564-26.732-30.558-46.297-24.553c-19.565,6.005-30.557,26.732-24.553,46.297 c6.005,19.565,26.732,30.557,46.297,24.553C433.551,225.873,444.542,205.145,438.539,185.58z M408.141,212.831 c-9.046,2.777-18.63-2.307-21.407-11.352c-2.777-9.046,2.307-18.63,11.352-21.407c9.046-2.777,18.63,2.306,21.407,11.352 S417.186,210.055,408.141,212.831z"
															></path>
														</g>
													</g>
													<g>
														<g>
															<path
																d="M240.83,246.257c-6.004-19.564-26.731-30.558-46.297-24.553c-19.564,6.005-30.557,26.732-24.553,46.297 s26.732,30.558,46.297,24.553C235.841,286.549,246.834,265.822,240.83,246.257z M210.433,273.508 c-9.046,2.777-18.63-2.307-21.407-11.352c-2.777-9.046,2.306-18.63,11.352-21.407c9.046-2.777,18.63,2.307,21.407,11.352 C224.561,261.148,219.478,270.732,210.433,273.508z"
															></path>
														</g>
													</g>
													<g>
														<g>
															<path
																d="M511.963,359.98l-7.568-92.963l-13.972-47.224c9.498-5.563,14.301-17.098,10.93-28.079 c-3.936-12.827-17.526-20.034-30.353-16.097l-13.124,4.027c9.346,30.451-7.889,62.343-37.956,71.571 c-29.738,9.128-62.148-7.256-71.571-37.956l-88.18,27.063c9.346,30.451-7.889,62.344-37.957,71.571 c-29.743,9.129-62.151-7.261-71.571-37.957l-4.786,1.469c-12.827,3.936-20.034,17.526-16.097,30.353 c3.104,10.111,12.206,16.725,22.204,17.146l3.419,11.141c6.21,20.233,27.647,31.602,47.879,25.392l32.919-10.104l68.136,65.089 h-79.715c-7.759,0-14.049,6.29-14.049,14.049s6.29,14.049,14.049,14.049h215.578c7.759,0,14.049-6.29,14.049-14.049 s-6.29-14.049-14.049-14.049h-76.38l140.483-43.115C509.185,369.803,512.38,365.092,511.963,359.98z M325.429,400.134 l-41.3-39.453l92.038-28.246l14.622,47.64L325.429,400.134z M414.61,372.764l-14.622-47.64l82.086-25.193l4.14,50.857 L414.61,372.764z"
															></path>
														</g>
													</g>
												</g>
											</svg>
										</div>
										<h3 class="mt-3 text-lg font-medium">
											Accident
										</h3>
									</div>
								</label>

								<!-- Theft Option -->
								<label class="claim-type-card">
									<input
										type="radio"
										v-model="form.claim_type"
										value="theft"
										class="sr-only"
									/>
									<div
										class="claim-type-content"
										:class="{
											selected:
												form.claim_type === 'theft',
										}"
									>
										<div class="icon-container">
											<!-- Theft SVG -->

											<svg
												fill="#000000"
												height="100px"
												width="100px"
												version="1.2"
												baseProfile="tiny"
												id="Layer_1"
												xmlns="http://www.w3.org/2000/svg"
												xmlns:xlink="http://www.w3.org/1999/xlink"
												viewBox="0 0 256 256"
												xml:space="preserve"
											>
												<g
													id="SVGRepo_bgCarrier"
													stroke-width="0"
												></g>
												<g
													id="SVGRepo_tracerCarrier"
													stroke-linecap="round"
													stroke-linejoin="round"
												></g>
												<g id="SVGRepo_iconCarrier">
													<path
														id="XMLID_1_"
														d="M92.4,192.7c-6.3,6.4-12.9,12.9-18.3,18.3l34.2,41l34.2-41c-6-6.2-12.4-12.1-18.3-18.3H92.4z M62.1,169.9 l12.3,12.3l-2.7,2.7l-12.3-12.3L62.1,169.9z M110.2,157.8v17.4h-3.8v-17.4H110.2z M154.4,169.9l-12.3,12.3l2.7,2.7l12.3-12.3 L154.4,169.9z M220.9,89.3c-2.4,4.7-4.8,9.5-7.1,14.5L191,176.3c-1.1,6.6-6.9,11.7-13.8,11.7c-7.7,0-14-6.3-14-14 c0-0.8,0.1-1.6,0.2-2.3l-0.2-0.1l3.3-13.3c2.6-14.1,12.6-36.7-18.3-42.5c-32.2-6.1-63.5,21.5-63.5,21.5 c-11.9,8.8-23.6,20.1-32.9,34.8c-2.3,3.6-6.1,5.5-10.1,5.5c-2.2,0-4.4-0.6-6.4-1.9c-5.6-3.5-7.2-10.9-3.7-16.5 c15.3-24,35.7-40.4,53.9-51.1c0.2-0.1,0.3-0.2,0.4-0.3c0.4-0.4,0-1.1-0.6-1.1c-0.2,0-0.3,0-0.5,0.1c-32.9,13.5-60.6,29.6-61,29.8 c-1.9,1.1-4,1.6-6,1.6c-4.1,0-8.1-2.1-10.3-5.9c-3.3-5.7-1.4-13,4.3-16.4c1.5-0.9,26.8-15.6,58.5-29c0.4-0.2,0.5-0.3,0.6-0.5 c0.1-0.3,0-0.7-0.2-0.9c-0.4-0.3-0.8-0.1-0.8-0.1l-43.2,6.8c-0.6,0.1-1.3,0.1-1.9,0.1C19,92.4,14,88.2,13,82.3 c-1-6.5,3.4-12.6,9.9-13.7l42.7-6.8l-0.5-0.1c0,0,36.3-5.3,78.3-21.9c23.5-9.3,38-26.5,49.6-39.8h63v39.5L220.9,89.3z"
													></path>
												</g>
											</svg>
										</div>
										<h3 class="mt-3 text-lg font-medium">
											Theft
										</h3>
									</div>
								</label>
							</div>
						</div>

						<!-- Description -->
						<div>
							<label
								for="remarks"
								class="block text-lg font-semibold text-gray-800 mb-4"
							>
								Description of Incident
								<span class="text-red-500 text-base">*</span>
							</label>
							<textarea
								id="remarks"
								v-model="form.remarks"
								rows="6"
								required
								placeholder="Please describe what happened, location, time, other parties involved, etc..."
								class="w-full px-5 py-4 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 resize-y text-gray-700"
							></textarea>
						</div>

						<!-- Buttons -->
						<div class="flex flex-col sm:flex-row gap-4 pt-6">
							<button
								type="button"
								@click="closeModal"
								class="flex-1 py-3.5 px-6 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-xl transition duration-200 focus:outline-none focus:ring-2 focus:ring-gray-400"
							>
								Cancel
							</button>

							<button
								type="submit"
								class="flex-1 py-3.5 px-6 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-xl shadow-md transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
								:disabled="
									!form.claim_type || !form.remarks.trim()
								"
							>
								Save Claim Report
							</button>
						</div>
					</form>
				</div>
				<div class="flex justify-center my-6">
					<a
						href="/about-claims"
						class="inline-flex items-center gap-2 rounded-full bg-green-800 px-6 py-3 text-white font-semibold text-sm shadow-md hover:bg-green-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200"
					>
						Learn More About Claims
						<svg
							xmlns="http://www.w3.org/2000/svg"
							class="h-4 w-4"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M13 7l5 5m0 0l-5 5m5-5H6"
							/>
						</svg>
					</a>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	components: {
		Modal: () => import('@/components/newportal/templates/others/modal'),
	},

	data() {
		return {
			form: {
				claim_type: '',
				remarks: '',
			},
		};
	},

	computed: {
		...mapGetters(['showReportClaim']),
	},

	methods: {
		closeModal() {
			this.form = { claim_type: '', remarks: '' }; // reset form
			this.$store.commit('showReportClaim', false);
		},

		handleSubmit() {
			if (!this.form.claim_type || !this.form.remarks.trim()) return;

			console.log('Submitting claim:', this.form);

			// → Here you would normally dispatch to Vuex / API
			// this.$store.dispatch('submitClaimReport', this.form)
			this.$router.push('/newportal/complete-claim');
			alert('Claim report submitted successfully!');
			this.closeModal();
		},
	},
};
</script>

<style scoped>
.claim-type-card {
	cursor: pointer;
	user-select: none;
}

.claim-type-content {
	@apply flex flex-col items-center p-6 border-2 border-gray-200 rounded-xl bg-white
           transition-all duration-200 hover:border-blue-300 hover:shadow-md;
}

.claim-type-content.selected {
	@apply border-blue-500 bg-blue-50 shadow-lg ring-2 ring-blue-200;
}

.icon-container {
	@apply text-gray-600 mb-2 transition-colors duration-200;
}

.claim-type-content.selected .icon-container {
	@apply text-blue-600;
}

.claim-type-content:hover .icon-container {
	@apply text-blue-500;
}
</style>
